module.exports = __webpack_public_path__ + "static/media/tnb.af3f37f6.svg";